import React, { useEffect, useState } from "react";
import request from "../../Helpers/API";
import Swal from "sweetalert2";
import { MenuList } from "../components/Menu_List";

export const ListadoAuditoria = () => {
    const [cards, setCards] = useState([]);


    useEffect(() => {
        request
            .get(`MenuUsuarios/AccesosMenus?idmodulo=18`)
            .then((result) => {
                const cards_array = result.map((item) => ({
                    titulo: item.titulo,
                    ruta: item.ruta,
                }));
                setCards(cards_array);
            })
            .catch((error) => {
                Swal.fire("MENUS POSTVENTA", JSON.stringify(error), "error");
            });
    }, []);
    return (
        <MenuList titulo={"LISTADO DE AUDITORIA"} cards={cards} />
    );
};
